import NavResponsiveModal, {
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/components/Navigation/NavResponsiveModal';
import { PrimaryButton, SecondaryButton, Body } from '@/styles/blocks';

const DeleteOrderModal = ({ open, onClose, order, loading, deleteOrder }) => {
    return (
        <NavResponsiveModal open={open} onClose={onClose}>
            <ModalHeader title="Delete Order?" onClose={onClose} />
            <ModalContent>
                <Body>Are you sure you want to delete this order?</Body>
            </ModalContent>
            <ModalActions>
                <SecondaryButton onClick={onClose} disabled={loading}>
                    Cancel
                </SecondaryButton>
                <PrimaryButton
                    onClick={() => {
                        deleteOrder(order);
                    }}
                    loading={loading}
                    disabled={loading}
                >
                    Delete
                </PrimaryButton>
            </ModalActions>
        </NavResponsiveModal>
    );
};

export default DeleteOrderModal;
